// Arquitectura de navegación por perfil.
// Cada perfil es una lista de secciones; las secciones con `label` son
// grupos colapsables, las que no lo tienen se muestran planas.
// SideNav.js consume esta estructura.

const CCESEN_BASE = [
    { to: '/erecursos', icon: 'fa-book', label: 'E-Recursos' },
    { to: '/catalogo', icon: 'fa-search', label: 'Catálogo' },
    { to: '/tematicas', icon: 'fa-map-signs', label: 'Guías temáticas' },
    { to: '/inicio', icon: 'fa-bookmark', label: 'Libros nuevos' },
    { to: '/prestamos', icon: 'fa-exchange', label: 'Préstamos activos' },
    { to: '/salas', icon: 'fa-users', label: 'Salas colectivas' },
];

const REGISTRO_ADMIN = [
    { to: '/alumnosnotas', icon: 'fa-bar-chart', label: 'Notas' },
    { to: '/admincum', icon: 'fa-diamond', label: 'CUM' },
    { to: '/adminhorassociales', icon: 'fa-hourglass-half', label: 'Horas sociales' },
    { to: '/adminalumnimateriasinscritas', icon: 'fa-folder-open', label: 'Materias inscritas' },
    { to: '/adminpracticas', icon: 'fa-briefcase', label: 'Prácticas profesionales' },
    { to: '/admintoefl', icon: 'fa-globe', label: 'Toefl' },
];

const FINANZAS_ADMIN = [
    { to: '/alumnossolvencia', icon: 'fa-user-circle-o', label: 'Solvencia de alumnos' },
    { to: '/alumnossaldo', icon: 'fa-usd', label: 'Saldos de alumnos' },
    { to: '/dtefinanzas', icon: 'fa-file-text-o', label: 'DTEs' },
    { to: '/admincargomora', icon: 'fa-money', label: 'Cargos y moras CC' },
    { to: '/fechaspago', icon: 'fa-calendar-check-o', label: 'Fechas de pago' },
    { to: '/admintalonario', icon: 'fa-ticket', label: 'Talonarios' },
];

const PASANTIAS_ADMIN = [
    { to: '/pasantias', icon: 'fa-plus-circle', label: 'Crear pasantía' },
    { to: '/adminpasantiasall', icon: 'fa-briefcase', label: 'Pasantías' },
    { to: '/adminpasantiasalloff', icon: 'fa-toggle-off', label: 'Pasantías OFF' },
    { to: '/pasantiasalumnosb', icon: 'fa-search', label: 'Pasantías alumnos' },
    { to: '/pasantiaspf', icon: 'fa-question-circle', label: 'Preguntas frecuentes' },
    { to: '/pasantiastips', icon: 'fa-lightbulb-o', label: 'Tips sobre pasantías' },
];

const PIE_COMUN = [
    { to: '/socialmedia', icon: 'fa-camera-retro', label: 'Redes sociales' },
    { to: '/manualestilo', icon: 'fa-paint-brush', label: 'Manual de estilo' },
];

const navConfig = {

    alumnos: [
        {
            items: [
                { to: '/dashboard', icon: 'fa-th-large', label: 'Inicio' },
                { to: '/eventos', icon: 'fa-calendar', label: 'Eventos' },
                { to: '/notificaciones', icon: 'fa-bullhorn', label: 'Notificaciones' },
                { to: '/correo', icon: 'fa-envelope-o', label: 'Correo electrónico' },
                { to: '/directorio', icon: 'fa-address-book', label: 'Directorio ESEN' },
                { to: '/canchas', icon: 'fa-futbol-o', label: 'Espacios deportivos' },
            ],
        },
        {
            key: 'registro', label: 'Registro Académico', icon: 'fa-graduation-cap',
            items: [
                { to: '/home', icon: 'fa-clock-o', label: 'Horario de clases' },
                { to: '/notas', icon: 'fa-bar-chart', label: 'Notas' },
                { to: '/cum', icon: 'fa-diamond', label: 'CUM' },
                { to: '/horassociales', icon: 'fa-hourglass-half', label: 'Horas sociales' },
                { to: '/practicasprofesionales', icon: 'fa-briefcase', label: 'Prácticas profesionales' },
                { to: '/toefl', icon: 'fa-globe', label: 'Toefl' },
            ],
        },
        {
            key: 'finanzas', label: 'Finanzas', icon: 'fa-credit-card',
            items: [
                { to: '/solvencia', icon: 'fa-check-circle-o', label: 'Solvencia' },
                { to: '/saldo', icon: 'fa-usd', label: 'Saldos' },
                { to: '/dtealumnos', icon: 'fa-file-text-o', label: 'Facturas (DTE)' },
                { to: '/fechaspago', icon: 'fa-calendar-check-o', label: 'Fechas de pago' },
                { to: '/talonario', icon: 'fa-ticket', label: 'Talonarios' },
                { to: '/finanbibliocargomoras', icon: 'fa-money', label: 'Cargos y moras CC' },
            ],
        },
        {
            key: 'ccesen', label: 'CCESEN · Biblioteca', icon: 'fa-university',
            items: [
                ...CCESEN_BASE,
                { to: '/bibliocargomoras', icon: 'fa-money', label: 'Cargos y moras' },
            ],
        },
        {
            key: 'de', label: 'Dirección Estudiantil', icon: 'fa-compass',
            items: [
                { to: '/pasantiasalumnos', icon: 'fa-briefcase', label: 'Pasantías' },
                { to: '/pasantiascv', icon: 'fa-address-card-o', label: 'Curriculum vitae' },
                { to: '/pasantiaspf', icon: 'fa-question-circle', label: 'Preguntas frecuentes' },
                { to: '/pasantiastips', icon: 'fa-lightbulb-o', label: 'Tips sobre pasantías' },
            ],
        },
        { items: PIE_COMUN },
    ],

    admin: [
        {
            items: [
                { to: '/eventos', icon: 'fa-calendar', label: 'Eventos' },
                { to: '/notificaciones', icon: 'fa-bullhorn', label: 'Notificaciones' },
                { to: '/correo', icon: 'fa-envelope-o', label: 'Correo electrónico' },
                { to: '/directorio', icon: 'fa-address-book', label: 'Directorio ESEN' },
                { to: '/canchas', icon: 'fa-futbol-o', label: 'Espacios deportivos' },
                { to: '/helpdesk', icon: 'fa-life-ring', label: 'HelpDesk' },
            ],
        },
        { key: 'ccesen', label: 'CCESEN · Biblioteca', icon: 'fa-university', items: CCESEN_BASE },
        {
            items: [
                ...PIE_COMUN,
                { to: '/passchange', icon: 'fa-key', label: 'Contraseña' },
            ],
        },
    ],

    finanzas: [
        {
            items: [
                { to: '/eventos', icon: 'fa-calendar', label: 'Eventos' },
                { to: '/notificaciones', icon: 'fa-bullhorn', label: 'Notificaciones' },
                { to: '/correo', icon: 'fa-envelope-o', label: 'Correo electrónico' },
                { to: '/directorio', icon: 'fa-address-book', label: 'Directorio ESEN' },
                { to: '/cicadmin', icon: 'fa-thermometer', label: 'Covid-19' },
                { to: '/helpdesk', icon: 'fa-life-ring', label: 'HelpDesk' },
            ],
        },
        { key: 'finanzas', label: 'Finanzas', icon: 'fa-credit-card', items: FINANZAS_ADMIN },
        { key: 'registro', label: 'Registro Académico', icon: 'fa-graduation-cap', items: REGISTRO_ADMIN },
        { key: 'ccesen', label: 'CCESEN · Biblioteca', icon: 'fa-university', items: CCESEN_BASE },
        {
            items: [
                ...PIE_COMUN,
                { to: '/passchange', icon: 'fa-key', label: 'Contraseña' },
            ],
        },
    ],

    direccionestudiantil: [
        {
            items: [
                { to: '/admineventoall', icon: 'fa-calendar', label: 'Eventos' },
                { to: '/correo', icon: 'fa-envelope-o', label: 'Correo electrónico' },
                { to: '/directorio', icon: 'fa-address-book', label: 'Directorio ESEN' },
                { to: '/cicadmin', icon: 'fa-thermometer', label: 'Covid-19' },
                { to: '/canchaconsultasladmin', icon: 'fa-futbol-o', label: 'Espacios deportivos' },
                { to: '/helpdesk', icon: 'fa-life-ring', label: 'HelpDesk' },
            ],
        },
        {
            key: 'noti', label: 'Notificaciones', icon: 'fa-bullhorn',
            items: [
                { to: '/alertmenu', icon: 'fa-plus-circle', label: 'Nueva notificación' },
                { to: '/notificaciones', icon: 'fa-eye', label: 'Ver notificaciones' },
            ],
        },
        { key: 'de', label: 'Dirección Estudiantil', icon: 'fa-compass', items: PASANTIAS_ADMIN },
        { key: 'ccesen', label: 'CCESEN · Biblioteca', icon: 'fa-university', items: CCESEN_BASE },
        {
            items: [
                ...PIE_COMUN,
                { to: '/passchange', icon: 'fa-key', label: 'Contraseña' },
            ],
        },
    ],

    superadmin: [
        {
            items: [
                { to: '/eventosaulas', icon: 'fa-calendar-check-o', label: 'Aulas y eventos' },
                { to: '/admineventoall', icon: 'fa-newspaper-o', label: 'Noticias y avisos' },
                { to: '/stati', icon: 'fa-line-chart', label: 'Estadísticas' },
                { to: '/correo', icon: 'fa-envelope-o', label: 'Correo electrónico' },
                { to: '/directorio', icon: 'fa-address-book', label: 'Directorio ESEN' },
                { to: '/cicadmin', icon: 'fa-thermometer', label: 'Covid-19' },
                { to: '/canchasadmin', icon: 'fa-futbol-o', label: 'Espacios deportivos' },
                { to: '/helpdesk', icon: 'fa-life-ring', label: 'HelpDesk' },
            ],
        },
        {
            key: 'noti', label: 'Notificaciones', icon: 'fa-bullhorn',
            items: [
                { to: '/alertmenu', icon: 'fa-plus-circle', label: 'Nueva notificación' },
                { to: '/notificaciones', icon: 'fa-eye', label: 'Ver notificaciones' },
            ],
        },
        { key: 'registro', label: 'Registro Académico', icon: 'fa-graduation-cap', items: REGISTRO_ADMIN },
        { key: 'finanzas', label: 'Finanzas', icon: 'fa-credit-card', items: FINANZAS_ADMIN },
        { key: 'de', label: 'Dirección Estudiantil', icon: 'fa-compass', items: PASANTIAS_ADMIN },
        {
            key: 'ccesen', label: 'CCESEN · Biblioteca', icon: 'fa-university',
            items: CCESEN_BASE.map((i) =>
                i.to === '/inicio' ? { ...i, label: 'Nueva bibliografía' } : i
            ),
        },
        {
            items: [
                ...PIE_COMUN,
                { to: '/passchange', icon: 'fa-key', label: 'Contraseña' },
            ],
        },
    ],
};

export default navConfig;
